<style lang="less" scoped>
	.editable {
		cursor: pointer;
	}
</style>

<template>
		<div>
			<v-card :width="element.attrs.width" :flat="element.attrs.flat" :dark="element.attrs.dark" v-bind:class="classes" :color="element.attrs.colors.background"  :id="element.id">
				<v-card-title :class="titleClasses">
					<v-text-field v-if="editing" v-model="element.title" v-on:blur="editing = false"  :class="titleClasses" placeholder="Card Title"></v-text-field>
					<div :class="{editable: focus == element }" v-else @click="editing = true" v-html="element.title"></div>
				</v-card-title>
				<v-card-text :class="textClasses">
					<v-textarea rows="3" v-if="editing" v-model="element.text" v-on:blur="editing = false" :class="textClasses" placeholder="Card Text"></v-textarea>
					<div :class="{editable: focus == element }" style="min-height: 50px;" v-else  @click="editing = true" v-html="element.text"></div>
				</v-card-text>
				<template  v-for="(childElement) in element.elements">
					<slot name="element" v-bind:childElement="childElement"></slot>
				</template>
			</v-card>
		</div>
		
</template>




<script type="text/javascript">
	export default {
		name: "EditorCard",
		props: {
			focus: {type: Object },
			element: {type: Object}
		},
		data: () =>{
			return {
				editing: false,
			}
		}, 
		computed:{
			titleClasses(){
				var object = {}				
				object[ this.element.attrs.typography.title ] = true;
				object[ this.element.attrs.alignment.title ] = true;
				object[ this.element.attrs.colors.title + "--text"] = true;
				return object;
			},
			textClasses(){
				var object = {}				
				object[ this.element.attrs.typography.text ] = true;
				object[ this.element.attrs.alignment.text ] = true;
				object[ this.element.attrs.colors.text + "--text"] = true;
				return object;
			},
			classes(){
				var object = {}
				object[this.element.attrs.padding] = this.element.attrs.padding ? true : false;
				object[this.element.attrs.margin] = this.element.attrs.margin ? true : false;
				return object;
			}
		},
		methods: {

		},
		watch:{
			focus: {
				immediate:true,
				handler(){
					if( this.focus == this.element ){
						this.editing = true
					}
					else{
						this.editing = false
					}
				}
			}
		}
	}
</script>

